<template>
  <div class="flex items-center justify-center min-h-screen">
    <div class="text-center">
      <svg class="w-16 h-16 mx-auto mb-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z">
        </path>
      </svg>
      <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">Wallpaper Not Found</h2>
      <p class="text-gray-600 dark:text-gray-300 mb-6">{{ error || 'The requested wallpaper could not be found.' }}</p>
      <button
        @click="$emit('back-to-home')"
        class="px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-semibold transition-colors"
      >
        Back to Home
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  error?: string;
}>();

defineEmits(['back-to-home']);
</script>
